import {VGMap} from "../../../../../modules/index.esm";

$(document).on('click', '[data-ajax-modal]', function () {
	let route = $(this).attr('href');
	let params = $(this).data();

	$.get(route, params, function (data) {
		let $container = $('.modals-container');
		$container.append(data.view);

		let $modal = $container.find('.modal').last();
		$modal.modal('show');

		let $maps = document.querySelectorAll('[data-vg-map]');

		if ($maps.length) {
			for (let $map of $maps) {
				VGMap.init($map);
			}
		}

		let $modalOrderPoint = $('.modal-order-point');
		if ($modalOrderPoint.length) {
			$(document).on('click', '[data-toggle-order-info]', function () {
				$modalOrderPoint.toggleClass('show');

				return false;
			});
		}

		$modal.on('hidden.bs.modal', event => {
			$modal.remove();
		});
	});

	return false;
});
